@switch (entry.type) {
  @case ('body') {
    <div>
      {{ entry.text }}
    </div>
  }
  @case ('caption') {
    <div class="caption">
      {{ entry.text }}
    </div>
  }
}
